var map = {
	"./decidim/avatar-multiuser.png": 29973,
	"./decidim/brands/facebook.svg": 71665,
	"./decidim/brands/google.svg": 39304,
	"./decidim/brands/twitter-x.svg": 24685,
	"./decidim/cc-badge.png": 26387,
	"./decidim/decidim-logo.svg": 93847,
	"./decidim/default-avatar.svg": 51099,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 33169,
	"./decidim/icons.svg": 46922,
	"./decidim/pattern.png": 71993,
	"./decidim/placeholder-card-g.svg": 13366,
	"./decidim/placeholder-card-l.svg": 99677,
	"./decidim/placeholder.jpg": 35932,
	"./decidim/remixicon.symbol.svg": 55854,
	"./decidim/vendor/social-share-button/douban.svg": 98865,
	"./decidim/vendor/social-share-button/email.svg": 75762,
	"./decidim/vendor/social-share-button/facebook.svg": 92538,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 98838,
	"./decidim/vendor/social-share-button/hacker_news.svg": 38370,
	"./decidim/vendor/social-share-button/linkedin.svg": 30752,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 84313,
	"./decidim/vendor/social-share-button/pinterest.svg": 33452,
	"./decidim/vendor/social-share-button/reddit.svg": 80697,
	"./decidim/vendor/social-share-button/telegram.svg": 59991,
	"./decidim/vendor/social-share-button/tumblr.svg": 97236,
	"./decidim/vendor/social-share-button/twitter.svg": 34311,
	"./decidim/vendor/social-share-button/vkontakte.svg": 47925,
	"./decidim/vendor/social-share-button/wechat.svg": 1880,
	"./decidim/vendor/social-share-button/whatsapp.svg": 51576,
	"./decidim/vendor/social-share-button/x.svg": 2994,
	"./decidim/vendor/social-share-button/xing.svg": 54486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84894;